<p class="first-access-modal__lead">
    Estamos quase lá. Agora precisamos verificar seus dados de acesso para garantir a integridade da sua conta.
</p>

<div *ngIf="isLoading" class="first-access-security-loading">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Carregando status...</span>
</div>

<ng-container *ngIf="!isLoading && verificationStatus">
    <div class="first-access-security-grid">
        <div class="first-access-security-channel">
            <label>Código por e-mail</label>
            <span class="first-access-channel-recipient" [title]="verificationStatus.email">
                {{ verificationStatus.email }}
            </span>

            <div
                *ngIf="emailChannelUnavailable && !verificationStatus.email_verified"
                class="first-access-channel-unavailable"
                role="status">
                <mat-icon>schedule</mat-icon>
                <span>
                    O envio do código por e-mail está indisponível agora. Tente verificar o e-mail mais tarde.
                </span>
            </div>

            <mat-form-field
                *ngIf="!emailChannelUnavailable || verificationStatus.email_verified"
                appearance="outline"
                class="first-access-code-field"
                [class.first-access-code-field--valid]="verificationStatus.email_verified"
                [class.first-access-code-field--error]="!!emailCodeError && !verificationStatus.email_verified"
                [class.first-access-code-field--busy]="emailVerifying">
                <mat-icon matPrefix>mail_outline</mat-icon>
                <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    placeholder="000000"
                    [value]="emailFieldValue"
                    [readonly]="verificationStatus.email_verified || emailVerifying"
                    [disabled]="emailVerifying"
                    (input)="onCodeInput($event, 'email')"
                    (keyup.enter)="verifyEmailCode()">
                <mat-spinner *ngIf="emailVerifying" matSuffix diameter="18"></mat-spinner>
                <mat-icon *ngIf="verificationStatus.email_verified" matSuffix>check_circle</mat-icon>
            </mat-form-field>

            <small *ngIf="verificationStatus.email_verified" class="first-access-valid-message">Código validado</small>
            <small *ngIf="!verificationStatus.email_verified && emailCodeError" class="first-access-invalid-message">
                {{ emailCodeError }}
            </small>
            <button
                *ngIf="!verificationStatus.email_verified && !emailChannelUnavailable"
                type="button"
                class="first-access-link-button first-access-channel-action"
                [disabled]="emailSending || emailCooldown > 0 || !verificationStatus.email"
                (click)="sendEmailVerification()">
                <mat-spinner *ngIf="emailSending" diameter="14"></mat-spinner>
                <span *ngIf="emailCooldown > 0">Reenviar e-mail ({{ emailCooldown }}s)</span>
                <span *ngIf="emailCooldown <= 0">{{ emailCodeSent ? 'Reenviar e-mail' : 'Enviar e-mail' }}</span>
            </button>
        </div>

        <div class="first-access-security-channel">
            <label class="first-access-channel-label">
                Código por SMS
                <span class="first-access-channel-optional">opcional</span>
            </label>
            <span class="first-access-channel-recipient" [title]="verificationStatus.phone_number || 'Telefone não cadastrado'">
                {{ verificationStatus.phone_number || 'Telefone não cadastrado' }}
            </span>

            <mat-form-field
                appearance="outline"
                class="first-access-code-field"
                [class.first-access-code-field--valid]="verificationStatus.phone_verified"
                [class.first-access-code-field--error]="!!phoneCodeError && !verificationStatus.phone_verified"
                [class.first-access-code-field--disabled]="!hasPhoneNumber"
                [class.first-access-code-field--busy]="phoneVerifying">
                <mat-icon matPrefix>phone_iphone</mat-icon>
                <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    placeholder="000000"
                    [value]="phoneFieldValue"
                    [readonly]="verificationStatus.phone_verified || phoneVerifying || !hasPhoneNumber"
                    [disabled]="phoneVerifying || !hasPhoneNumber"
                    (input)="onCodeInput($event, 'phone')"
                    (keyup.enter)="verifyPhoneCode()">
                <mat-spinner *ngIf="phoneVerifying" matSuffix diameter="18"></mat-spinner>
                <mat-icon *ngIf="verificationStatus.phone_verified" matSuffix>check_circle</mat-icon>
            </mat-form-field>

            <small *ngIf="verificationStatus.phone_verified" class="first-access-valid-message">Código validado</small>
            <small *ngIf="!verificationStatus.phone_verified && phoneCodeError" class="first-access-invalid-message">
                {{ phoneCodeError }}
            </small>
            <small *ngIf="!verificationStatus.phone_verified && !hasPhoneNumber" class="first-access-invalid-message">
                Telefone não cadastrado.
            </small>
            <small *ngIf="!verificationStatus.phone_verified && phoneChannelUnavailable" class="first-access-channel-unavailable-note">
                Envio por SMS indisponível no momento.
            </small>
            <button
                *ngIf="!verificationStatus.phone_verified && hasPhoneNumber && !phoneChannelUnavailable"
                type="button"
                class="first-access-link-button first-access-channel-action"
                [disabled]="phoneSending || phoneCooldown > 0"
                (click)="sendSmsVerification()">
                <mat-spinner *ngIf="phoneSending" diameter="14"></mat-spinner>
                <span *ngIf="phoneCooldown > 0">Reenviar SMS ({{ phoneCooldown }}s)</span>
                <span *ngIf="phoneCooldown <= 0">{{ phoneCodeSent ? 'Reenviar SMS' : 'Enviar SMS' }}</span>
            </button>
        </div>
    </div>
</ng-container>

<div *ngIf="!isLoading && !verificationStatus" class="first-access-status-error">
    <mat-icon>error_outline</mat-icon>
    <span>Não foi possível carregar o status.</span>
</div>

<div class="first-access-warning">
    <mat-icon>info</mat-icon>
    <span>Os códigos expiram em 2 horas. Certifique-se de verificar a caixa de Spam ou Lixo Eletrônico.</span>
</div>
